import HomeScreen from "./screens/HomeScreen/HomeScreen";
import LoginScreen from "./screens/LoginScreen/LoginScreen";
import ResetPasswordScreen from "./screens/ResetPasswordScreen/ResetPasswordScreen";
import { Routes, Route, BrowserRouter, Navigate, createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import "./App.css";
import AuthContext from "./store/AuthContext";
import { useContext } from "react";
import TranscriptDetailScreen from "./screens/TranscriptDetailScreen/TranscriptDetailScreen";
import SettingsScreen from "./screens/SettingsScreen/SettingsScreen";
import UserScreen from "./screens/UserScreen/UserScreen";
import OrgScreen from "./screens/OrgScreen/OrgScreen";
import UploadScreen from "./screens/UploadScreen/UploadScreen";
import PromptScreen from "./screens/PromptScreen.js/PromptsScreen";
import UploadDetailScreen from "./screens/UploadDetailScreen/UploadDetailsScreen";
import RecordScreen from "./screens/RecordScreen/RecordScreen";
import BastionGPTScreen from "./screens/BastionGPTScreen/BastionGPTScreen";
import TwoFactorAuth from "./screens/TwoFactorAuth/TwoFactorAuth";

function App() {
  const authCtx = useContext(AuthContext);

  const routes = [
    { path: "/", element: <HomeScreen />, isProtected: true },
    { path: "transcript-details", element: <TranscriptDetailScreen />, isProtected: true },
    { path: "upload-details", element: <UploadDetailScreen />, isProtected: true },
    { path: "settings", element: <SettingsScreen />, isProtected: true, adminOnly: true },
    { path: "users", element: <UserScreen />, isProtected: true, adminOnly: true },
    { path: "organizations", element: <OrgScreen />, isProtected: true, superAdminOnly: true },
    { path: "upload", element: <UploadScreen />, isProtected: true },
    { path: "dictate", element: <RecordScreen />, isProtected: true },
    { path: "prompt", element: <PromptScreen />, isProtected: true },
    { path: "InteliDoc-GPT", element: <BastionGPTScreen />, isProtected: true },
    { path: "login", element: <LoginScreen /> },
    { path: "twoFactorAuthentication", element: <TwoFactorAuth /> },
    { path: "reset-password", element: <ResetPasswordScreen /> },
  ];

  const createRoute = (route) => {
    if (route.isProtected) {
      if (!authCtx.isLoggedIn) {
        return <Route key={route.path} path={route.path} element={<Navigate to="/login" />} />;
      }

      if (route.adminOnly && !(authCtx.isAdmin || authCtx.isSuperAdmin)) {

        return <Route key={route.path} path={route.path} element={<Navigate to="" />} />;
      }

      if (route.superAdminOnly && !authCtx.isSuperAdmin) {
        return <Route key={route.path} path={route.path} element={<Navigate to="" />} />;
      }
    }

    return <Route key={route.path} path={route.path} element={route.element} />;
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/">
        {routes.map(createRoute)}
      </Route>
    ),
  );

  return <RouterProvider router={router} />;
}

export default App;
